export default __webpack_public_path__ + "85d341363383fa81fcb0624d53cb1a50.png";